import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PortfolioService } from "../../pages/portfolio/portfolio.service";
import { PortfolioModel } from "../../shared/models/portfolio.model";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from "@angular/forms";
import { BenchmarkCategoryPanelComponent } from "../benchmark-category-panel/benchmark-category-panel.component";

@Component({
  selector: "app-benchmark-selector-for-views",
  templateUrl: "./benchmark-selector-for-views.component.html",
  styleUrls: ["./benchmark-selector-for-views.component.scss"],
  standalone: true,
  imports: [MaterialModule, FormsModule, BenchmarkCategoryPanelComponent],
})
export class BenchmarkSelectorForViewsComponent {
  @Input() showLabel = false;
  @Input() label = "View";
  @Input() benchmarkPlaceholder = "Select benchmark";
  @Input() selectedBenchmark: any;
  @Input() isFullWidth = false;
  @Output() benchmarkSelect: EventEmitter<any> = new EventEmitter<any>();

  benchmarks: any[] = [];
  portfolios: any[] = [];

  commodities: any[] = [];
  currencies: any[] = [];
  indices: any[] = [];
  rates: any[] = [];
  inflation: any[] = [];
  growth: any[] = [];
  volatility: any[] = [];
  conditions: any[] = [];

  portfolio = new PortfolioModel({});

  searchText = "";
  benchmarksHidden = false;
  portfoliosHidden = false;
  constructor(private service: PortfolioService) {}

  ngOnInit(): void {
    this.fetchBenchmarks();
    this.getPortfolioList();
    this.checkSelectedBenchmark();
  }

  ngOnChanges(): void {
    this.checkSelectedBenchmark();
  }

  async fetchBenchmarks() {
    var resp = await this.service.getBenchmarks();
    resp.subscribe((res: any) => {
      if (res) {
        this.benchmarks = res;
        this.reorganizeBenchmarks();
      }
    });
  }
  reorganizeBenchmarks() {
    this.commodities = [];
    this.currencies = [];
    this.indices = [];
    this.rates = [];
    this.inflation = [];
    this.growth = [];
    this.volatility = [];
    this.conditions = [];
    this.benchmarks.forEach((b) => {
      if (b.group === "Commodities") {
        this.commodities = b.items;
      } else if (b.group === "Currency") {
        this.currencies = b.items;
      } else if (b.group === "Rates") {
        this.rates = b.items;
      } else if (b.group === "Inflation") {
        this.inflation = b.items;
      } else if (b.group === "Growth") {
        this.growth = b.items;
      } else if (b.group === "Volatility") {
        this.volatility = b.items;
      } else if (b.group === "Financial Conditions") {
        this.conditions = b.items;
      } else {
        this.indices.push(b);
      }
    });
  }

  checkSelectedBenchmark() {
    if (this.selectedBenchmark) {
      // Fix benchmark name display
      if (this.selectedBenchmark.index_name_full) {
        this.selectedBenchmark.name_full =
          this.selectedBenchmark.index_name_full;
      }
    }
  }

  getPortfolioList() {
    if (this.service.portfolioLists) {
      return this.skipSelectedPortfolioFromList();
    }
    this.service.getItems().subscribe((resp: any) => {
      if (resp.error) {
        this.service.notificationService.open(resp.error);
      }
      resp = this.service.extractPortfolioData(resp);
      let lists = resp;

      // merge private and shared by me lists
      lists.private = [...lists.private, ...lists.shared_by_me];
      this.service.portfolioLists = lists;
      return this.skipSelectedPortfolioFromList();
    });
  }

  skipSelectedPortfolioFromList() {
    let portfolios = [];
    Object.entries(this.service.portfolioLists).map(
      ([key, values]: [string, any]) => {
        values.map((p: any) => {
          if (p.id != this.portfolio.id) {
            portfolios.push(p);
          }
        });
      },
    );
    portfolios.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase()
        ? 1
        : b.name.toLowerCase() > a.name.toLowerCase()
          ? -1
          : 0,
    );

    this.portfolios = portfolios;
  }
  onBenchmarkSelect(selected) {
    this.selectedBenchmark = selected;
    this.benchmarkSelect.emit(selected);
  }

  onSearchChange() {
    this.benchmarks = this.benchmarks.map((p) => {
      p.hidden = !p.items.filter((f) => !f.hidden).length;
      return p;
    });
    this.benchmarksHidden = !this.benchmarks.filter((p) => !p.hidden).length;
    this.portfoliosHidden = !this.portfolios.filter((p) => !p.hidden).length;
  }

  resetSearch() {
    this.searchText = "";
    this.benchmarksHidden = false;
    this.portfoliosHidden = false;
    this.benchmarks = this.benchmarks.map((p) => {
      p.hidden = false;
      p.items = p.items.map((b) => {
        b.hidden = false;
        return b;
      });
      return p;
    });
    this.portfolios = this.portfolios.map((p) => {
      p.hidden = false;
      return p;
    });
  }

  removeBenchmark() {
    this.selectedBenchmark = "";
    this.benchmarkSelect.emit(this.selectedBenchmark);
  }
}
